// How a signed-in account is named on screen. Apple's Hide My Email gives a
// random relay address (…@privaterelay.appleid.com) that means nothing to the
// person who owns it, so it is shown as "Apple (email hidden)" instead.

const APPLE_RELAY = /@privaterelay\.appleid\.com$/i;

export function isAppleRelayEmail(email: string | null | undefined): boolean {
  return !!email && APPLE_RELAY.test(email.trim());
}

/** The account as a person reads it: their email, or for a hidden Apple
 * address their name when we have it. */
export function accountLabel(email: string | null | undefined, name?: string | null): string {
  if (email && !isAppleRelayEmail(email)) return email;
  if (name?.trim()) return name.trim();
  if (!email) return 'your account';
  return 'Apple (email hidden)';
}

/** An account as the admin panel names it: the email, or for a hidden Apple
 * address the person's name, else "Apple (email hidden)" with the start of
 * the account id so two of them can be told apart. */
export function personLabel(email: string | null, name: string | null, userId: string): string {
  if (email && !isAppleRelayEmail(email)) return email;
  if (name?.trim()) return name.trim();
  const id = userId.slice(0, 8);
  return email ? `${accountLabel(email)} · ${id}` : id;
}
